<template>
    <div>
        <script :id="randomId" type="text/plain"></script>
    </div>
</template>
<script>
    import '../../../public/UEditor/ueditor.config.js'
    import '../../../public/UEditor/ueditor.all.min.js'
    import '../../../public/UEditor/lang/zh-cn/zh-cn.js'
    import '../../../public/UEditor/ueditor.parse.min.js'
    export default {
        name: 'ue',
        data () {
            return {
                randomId: 'editor_' + (Math.random() * 100000000000000000),
                editor: null,
                ready:false,
                config: {
                  // 编辑器不自动被内容撑高
                  autoHeightEnabled: false,
                  // 初始容器高度
                  initialFrameHeight: 240,
                  // 初始容器宽度
                  initialFrameWidth: '100%',
                  // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                  serverUrl: process.env.VUE_APP_BASE_API+"/gatewayWebsiteServer/ueditor/exec"
                }
            }
        },
        props: {
        value: {
            default: function() {
                    return ''
                }
            },
        },
        watch: {
            value: function(val, oldVal) {
                console.log(val)
            if (val != null  && this.ready) {
                this.editor = window.UE.getEditor(this.randomId, this.config);
                this.editor.setContent(val);
            }
        }
        },
        beforeDestroy() {
            // 组件销毁的时候，要销毁 UEditor 实例
            if(this.editor !== null && this.editor.destroy) {
                this.editor.destroy();
            }
        },
        mounted () {
            this.editor = window.UE.getEditor(this.randomId, this.config);
            console.log(this.editor)
            this.editor.addListener('ready',  () => {
                console.log(111111111111)
                this.ready = true;
                this.$emit('ready', this.editor);
            })
        },
        methods: {
            setText(con) {
                this.editor = window.UE.getEditor(this.randomId, this.config);
                this.editor.setContent(con);
            },
            // getUEContent () {
            //     return this.editor.getContent()
            // }
        },
    }
</script>